<template>
  <div>
        <span :class="starCountClass">
          <span v-if="starCount.starCount>0" style="display: flex">
                    <span>{{starCount.label}}</span>
            <span>
            <el-rate v-model="count"
                     :max="starCount.starCount"
                     style="line-height: 50px;padding-left: 10px;" size="mini" @change="onChange(count)"></el-rate>
          </span>
          <span>
             <el-link type="primary" :underline="false" @click="onZero">置零</el-link>
          </span>
          </span>
          <div v-else>
                    <span>{{starCount.label}}</span>
            <el-radio-group v-model="victorypointId" size="mini" @change="onVictoryPoint(victorypointId)">
                          <el-radio-button border
                                           v-for="(item, index) in victorypoints" :key="index"
                                           :label="item.rate">{{item.fromPoint}}-{{item.toPoint}}
                          </el-radio-button>
            </el-radio-group>
          </div>

        </span>

  </div>
</template>

<script>
  export default {
    name: 'star',
    props: ['starCount', 'defaultCount', 'starCountClass', 'victorypoints'],
    data () {
      return {
        count: 1,
        victorypointId: 0
      }
    },
    mounted () {
      this.count = this.defaultCount

    },
    methods: {
      onChange (count) {
        this.$emit('change', count)
      },
      onZero () {
        this.count = 0
        this.$emit('change', 0)
      },
      onVictoryPoint (val) {
        this.$emit('onVictoryPoint', val)
      }
    },
  }
</script>

<style scoped>

</style>
